export default __webpack_public_path__ + "static/media/card-adult-m.59360a90.jpg";